"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResult = void 0;
var react_1 = __importStar(require("react"));
var Type_1 = require("@nerdwallet/currency/components/Type");
var seo_analytics_1 = require("@nerdwallet/seo-analytics");
var useSegmentImpression_1 = require("../../lib/useSegmentImpression");
var search_result_module_css_1 = __importDefault(require("./search-result.module.css"));
var SearchResult = function (_a) {
    var data = _a.data, query = _a.query, position = _a.position, currentPage = _a.currentPage;
    var postId = data.postId, url = data.url, title = data.title, displayDate = data.displayDate, content = data.content;
    var analytics = (0, seo_analytics_1.useSegmentAnalytics)().analytics;
    var _b = (0, useSegmentImpression_1.useSegmentImpression)({
        eventName: "link_viewed",
        segmentAttributes: {
            entity_name: "onsite_search_result_link",
            link_copy: title,
            section_name: "onsite_search",
            link_position: position,
            destination_url: url,
            destination_content_id: postId,
        },
    }), segmentRef = _b.ref, eventId = _b.eventId;
    var onClick = (0, react_1.useCallback)(function () {
        analytics === null || analytics === void 0 ? void 0 : analytics.track("link_clicked", {
            entity_name: title,
            parent_event_id: eventId,
        });
    }, []);
    var urlParams = new URLSearchParams({
        trk_location: "ssrp",
        trk_query: encodeURIComponent(query),
        trk_page: String(currentPage),
        trk_position: String(position),
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var dateObj = new Date(displayDate || null);
    var date = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
    }).format(dateObj);
    return (react_1.default.createElement("div", { ref: segmentRef, key: postId, className: search_result_module_css_1.default.searchResult },
        react_1.default.createElement(Type_1.Type, { size: 3, component: "h3", className: search_result_module_css_1.default.resultHeadline },
            react_1.default.createElement("a", { href: "".concat(url, "?").concat(urlParams.toString()), onClick: onClick }, title)),
        displayDate ? (react_1.default.createElement(Type_1.Type, { inline: true, size: 2, color: "neutral-light" },
            date,
            " - ")) : null,
        content ? (react_1.default.createElement(Type_1.Type, { inline: true, size: 2 }, content)) : null));
};
exports.SearchResult = SearchResult;
exports.default = exports.SearchResult;
